export function getProductShareUrl(productId) {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    return `${origin}/detalle-producto/${productId}`;
}

/** Builds wa.me link from a phone string (digits only, with optional country code). */
export function getWhatsAppChatUrlFromPhone(phone, message = "") {
    const digits = String(phone ?? "").replace(/\D/g, "");
    if (!digits) return null;
    if (message) {
        return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
    }
    return `https://wa.me/${digits}`;
}

export function getFacebookShareUrl(productId) {
    const url = encodeURIComponent(getProductShareUrl(productId));
    return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
}

export function getWhatsAppShareUrl(productId) {
    const url = getProductShareUrl(productId);
    return `https://wa.me/?text=${encodeURIComponent(url)}`;
}

export function getTwitterShareUrl(productId, text) {
    const url = encodeURIComponent(getProductShareUrl(productId));
    const tweet = encodeURIComponent(text || "");
    return `https://twitter.com/intent/tweet?text=${tweet}&url=${url}`;
}

export async function copyProductLink(productId) {
    const url = getProductShareUrl(productId);
    if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        return true;
    }
    const textarea = document.createElement("textarea");
    textarea.value = url;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
}

export async function nativeShareProduct({ title, productId }) {
    const url = getProductShareUrl(productId);
    if (navigator.share) {
        await navigator.share({ title, url });
        return "shared";
    }
    const copied = await copyProductLink(productId);
    return copied ? "copied" : "failed";
}
